// extracted by mini-css-extract-plugin
export default {"editName":"common_editName__6+Xlr","actionButtons":"common_actionButtons__z6IQN","button":"common_button__4TX+u"};